:host {
  height: auto;
  width: auto;
}

.node-container--loading {
  opacity: 0.4;
}

.spinner {
  display: flex;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tree-loader {
  width: 220px;
  margin-right: var(--spacer);
}
